export default {
    INACTIVE: 0,
    ACTIVE: 1,
}